class Tooltip {
    constructor(container) {
        if (!container) {
            return null;
        }

        const content = container.dataset.tooltipContent ?? "";

        tippy(container, {
            content: content,
            arrow: true,
            placement: 'top',
            maxWidth: 336,
            animation: "shift-away"
        });
    }
}

document.addEventListener("DOMContentLoaded", function() {
    const selectors = {
        tooltip: "[data-tooltip]"
    };

    const tooltips = document.querySelectorAll(selectors.tooltip);

    if (!tooltips.length) {
        return;
    }

    tooltips.forEach((tooltip) => {
        new Tooltip(tooltip);
    });
});
